(() => {
  const storageKey = 'ferry:recent-partner';
  const maxContextAge = 30 * 60 * 1000;
  const body = document.body;

  const normalizeContext = (context) => {
    if (!context || typeof context.url !== 'string' || typeof context.name !== 'string') return null;

    try {
      const url = new URL(context.url, window.location.origin);
      const savedAt = Number(context.savedAt);
      const isRecent = Number.isFinite(savedAt) && Date.now() - savedAt <= maxContextAge;
      const isStorefront = url.origin === window.location.origin && url.pathname.startsWith('/collections/');
      const name = context.name.trim().slice(0, 100);

      if (!isRecent || !isStorefront || !name) return null;

      return { name, url: `${url.pathname}${url.search}`, savedAt };
    } catch (error) {
      return null;
    }
  };

  const currentContext = normalizeContext({
    name: body.dataset.ferryPartnerName,
    url: body.dataset.ferryPartnerUrl,
    savedAt: Date.now(),
  });

  if (currentContext) {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(currentContext));
    } catch (error) {
      // The server-rendered fallbacks continue to work when storage is unavailable.
    }
  }

  let recentContext = currentContext;

  if (!recentContext) {
    try {
      recentContext = normalizeContext(JSON.parse(window.sessionStorage.getItem(storageKey)));
      if (!recentContext) window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      recentContext = null;
    }
  }

  if (!recentContext) return;

  document.querySelectorAll('[data-partner-return]').forEach((link) => {
    link.href = recentContext.url;

    const label = link.querySelector('[data-partner-return-label]');
    if (label) label.textContent = `Back to ${recentContext.name}`;
  });
})();
